import type { Plugin } from './types';

const HIDDEN_PLUGINS = ['PI-DATEIO'];

export function filterPlugins(plugins: Plugin[]): Plugin[] {
    return plugins.filter((plugin) => !HIDDEN_PLUGINS.includes(plugin.productCode));
}
